module.exports = __webpack_public_path__ + "01_glasses_black.e5815f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/01_glasses_black.png
// module id = cfgG
// module chunks = 0